import React, { useState,useEffect  } from 'react';
import backgroundImage from './assets/login_background.jpg';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [alert, setAlert] = useState({ message: '', type: '' }); // New state for alert


   // Set page title
   useEffect(() => {
    document.title = 'Login - Calendar Services';
  }, []);



  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // const response = await fetch(`${API_BASE_URL}/login', {
        const response = await fetch(`${API_BASE_URL}/login`,{

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.success) {
        setAlert({ message: data.message, type: 'success' });
        localStorage.setItem('username', username);

        // Reset fields
        setUsername('');
        setPassword('');

        // Redirect after 2 seconds
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 500);
      } else {
        setAlert({ message: data.message, type: 'error' });

        // Reset fields
        setUsername('');
        setPassword('');
      }
    } catch (error) {
      console.error('Error logging in:', error);
      setAlert({ message: 'An error occurred. Please try again.', type: 'error' });

      // Reset fields
      setUsername('');
      setPassword('');
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div
        className="w-full max-w-md p-8 border border-gray-300 rounded-lg shadow-md"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.85)', // Add transparency
        }}
      >
        <h2 className="text-2xl font-semibold text-center text-gray-800">Login</h2>
        <p className="mt-2 text-center text-gray-600">Access your Calendar Services dashboard</p>

        <form onSubmit={handleLogin} className="mt-6 space-y-6">
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              className="w-full px-4 py-2 mt-1 text-gray-700 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              className="w-full px-4 py-2 mt-1 text-gray-700 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            Login
          </button>
        </form>

        <div className="mt-4 text-center">
          <a
            href="#"
            className="text-sm text-indigo-600 hover:underline"
          >
            Forgot your password?
          </a>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Don’t have an account?{' '}
            <a
              href="#"
              className="text-indigo-600 hover:underline"
            >
              Sign up
            </a>
          </p>
        </div>
      </div>

      {/* Alert Message */}
      {alert.message && (
        <div
          className={`fixed top-4 right-4 px-5 py-3 text-white rounded-lg shadow-lg ${
            alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          }`}


        >
          {alert.message}
        </div>
      )}
    </div>
  );
};

export default LoginPage;
